/* PC-MOBILE-FAQ-04: responsive charm sampling and exact shelf variant links. */
(() => {
  function shelfExamples(home) {
    const shelf=home.querySelector('[data-pop-shelf]');if(!shelf)return;
    const image=shelf.querySelector('[data-shelf-image]'),links=[...shelf.querySelectorAll('[data-shelf-link]')],link=links[0],toggle=shelf.querySelector('[data-shelf-motion]');let variants;
    try{variants=JSON.parse(shelf.querySelector('[data-shelf-variants]').textContent).filter(v=>v&&/^\d+$/.test(v.id)&&typeof v.name==='string'&&typeof v.src==='string'&&typeof v.price==='string'&&typeof v.url==='string'&&v.url.includes('?variant='+v.id));}catch(_){return;}
    if(!image||!link||!toggle||variants.length<2)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');let visible=false,paused=false,hovering=false,busy=false,disposed=false,timer,cancelImage,animation,incoming;
    let index=Math.max(0,variants.findIndex(v=>link.getAttribute('href')===v.url));
    const active=()=>visible&&!paused&&!hovering&&!disposed&&!document.hidden&&!reduced.matches&&!shelf.contains(document.activeElement);
    const permits=()=>active()&&!busy;
    const schedule=()=>{clearTimeout(timer);if(permits())timer=setTimeout(advance,8000);};
    const activity=(immediate=false)=>{clearTimeout(timer);if(!active()){cancelImage?.();animation?.cancel();animation=null;incoming?.remove();incoming=null;}toggle.hidden=reduced.matches;toggle.setAttribute('aria-pressed',String(paused));const label=toggle.querySelector('[data-motion-label]');if(label)label.textContent=paused?'Play':'Pause';toggle.setAttribute('aria-label',paused?'Play shelf examples':'Pause shelf examples');toggle.querySelector('[data-shelf-motion-symbol]').setAttribute('d',paused?'M5 2l13 8L5 18z':'M4 3h4v14H4zM12 3h4v14h-4z');if(immediate===true&&permits())advance();else schedule();};
    async function advance(){
      if(!permits())return;busy=true;const next=(index+1)%variants.length,v=variants[next];
      try{
        await new Promise((resolve,reject)=>{const preview=new Image();let deadline;const finish=fn=>{clearTimeout(deadline);preview.onload=preview.onerror=null;cancelImage=null;fn();};preview.onload=()=>finish(resolve);preview.onerror=()=>finish(reject);cancelImage=()=>finish(reject);deadline=setTimeout(cancelImage,10000);preview.src=v.src;});
        if(!active())return;
        incoming=image.cloneNode(false);incoming.removeAttribute('data-shelf-image');incoming.classList.add('ph-shelf__incoming');incoming.src=v.src;incoming.alt='';incoming.setAttribute('aria-hidden','true');image.parentElement.append(incoming);
        if(incoming.animate){animation=incoming.animate([{opacity:0},{opacity:1}],{duration:1100,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});await animation.finished.catch(()=>{});}
        if(!active())return;
        image.src=v.src;image.alt=v.name+' Magnetic Tray Shelf';links.forEach(item=>{item.href=v.url;item.setAttribute('aria-label','Shop the '+v.name+' Magnetic Tray Shelf');});shelf.querySelector('[data-shelf-color]').textContent=v.name;shelf.querySelector('[data-shelf-price]').textContent=v.price;index=next;
      }catch(_){/* An incomplete next frame never replaces the current product or variant link. */}finally{animation?.cancel();animation=null;incoming?.remove();incoming=null;busy=false;schedule();}
    }
    const observer=new IntersectionObserver(entries=>{const before=visible;visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.2;activity(visible&&!before);},{threshold:.2});observer.observe(shelf);
    const enter=e=>{if(e.pointerType!=='touch'){hovering=true;activity();}},leave=()=>{hovering=false;activity();},focusOut=()=>queueMicrotask(activity),pause=()=>{paused=!paused;activity();};
    shelf.addEventListener('pointerenter',enter);shelf.addEventListener('pointerleave',leave);shelf.addEventListener('focusin',activity);shelf.addEventListener('focusout',focusOut);toggle.addEventListener('click',pause);document.addEventListener('visibilitychange',activity);reduced.addEventListener('change',activity);
    const cleanup=event=>{if(event.target!==home&&!event.target.contains(home))return;disposed=true;clearTimeout(timer);cancelImage?.();animation?.cancel();incoming?.remove();animation=null;incoming=null;observer.disconnect();shelf.removeEventListener('pointerenter',enter);shelf.removeEventListener('pointerleave',leave);shelf.removeEventListener('focusin',activity);shelf.removeEventListener('focusout',focusOut);toggle.removeEventListener('click',pause);document.removeEventListener('visibilitychange',activity);reduced.removeEventListener('change',activity);document.removeEventListener('shopify:section:unload',cleanup);};document.addEventListener('shopify:section:unload',cleanup);activity();
  }
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pop-home]').forEach((home) => {
      if (home.dataset.ready) return;
      home.dataset.ready = 'true';
      shelfExamples(home);
      const gallery = home.querySelector('[data-pop-gallery]');
      if (gallery) {
        const filters = gallery.querySelector('[data-pop-filters]');
        const tiles = [...gallery.querySelectorAll('[data-pop-category]')];
        if (filters && tiles.length) {
          filters.hidden = false;
          const compact = window.matchMedia ? window.matchMedia('(max-width: 699px)') : {matches:false};
          let activeButton, matches = [];
          const render = (announce = true) => {
            const visibleTiles = matches.slice(0, compact.matches ? 8 : 12);
            const visible = new Set(visibleTiles);
            const focusedTile = tiles.find(tile => tile.contains(document.activeElement));
            tiles.forEach(tile => { tile.hidden = !visible.has(tile); });
            // Visible cards lead the grid, so the CSS eight-card guard also works during resize before JS runs.
            const grid = gallery.querySelector('.ph-designs__grid');
            if (grid) grid.append(...visibleTiles, ...tiles.filter(tile => !visible.has(tile)));
            if (focusedTile && !visible.has(focusedTile)) activeButton.focus({preventScroll:true});
            if (announce) gallery.querySelector('[data-pop-filter-status]').textContent = `${visible.size} of ${matches.length} charms shown.`;
          };
          const show = (button, announce = true) => {
            activeButton = button;
            const value = button.dataset.popFilter;
            matches = tiles.filter((tile) => value === 'all' || tile.dataset.popCategory.split('|').includes(value));
            if (value === 'all') for (let i = matches.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [matches[i], matches[j]] = [matches[j], matches[i]];
            }
            filters.querySelectorAll('button').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
            render(announce);
          };
          filters.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => show(button)));
          show(filters.querySelector('[data-pop-filter="all"]'), false);
          const resize = () => render();
          if (compact.addEventListener) compact.addEventListener('change', resize); else compact.addListener?.(resize);
          const cleanup = event => {
            if (event.target !== home && !event.target.contains(home)) return;
            if (compact.removeEventListener) compact.removeEventListener('change', resize); else compact.removeListener?.(resize);
            document.removeEventListener('shopify:section:unload', cleanup);
          };
          document.addEventListener('shopify:section:unload', cleanup);
        }
      }
      const board = home.querySelector('[data-pop-playground]');
      const toggle = home.querySelector('[data-pop-motion]');
      let library;
      try { library = JSON.parse(home.querySelector('[data-pop-library]').textContent); } catch (_) { return; }
      if (!board || !toggle || !Array.isArray(library)) return;
      const pieces = [...board.querySelectorAll('[data-pop-piece]')];
      if (!pieces.length || library.length <= pieces.length) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer, busy = false, paused = false, visible = false, hovering = false, disposed = false, lastSlot = -1;
      let animations = [], cancelPreload;
      const permitted = () => !disposed && !paused && !reduced.matches && visible && !document.hidden && !hovering && !board.contains(document.activeElement);
      const cancelAnimations = () => { animations.forEach((animation) => animation.cancel()); animations = []; };
      const updateToggle = () => {
        toggle.hidden = reduced.matches;
        toggle.setAttribute('aria-label', paused ? 'Play display animation' : 'Pause display animation');
        toggle.setAttribute('aria-pressed', String(paused));
        const label = toggle.querySelector('[data-motion-label]'); if (label) label.textContent = paused ? 'Play' : 'Pause';
        toggle.title = paused ? 'Play animation' : 'Pause animation';
        toggle.querySelector('[data-pop-motion-symbol]').setAttribute('d', paused ? 'M5 2l13 8L5 18z' : 'M4 3h4v14H4zM12 3h4v14h-4z');
      };
      const schedule = () => {
        clearTimeout(timer);
        if (permitted() && !busy) timer = setTimeout(swapOne, 600);
      };
      const changeActivity = (immediate = false) => {
        if (!permitted()) { cancelAnimations(); if (cancelPreload) cancelPreload(); }
        updateToggle(); if (immediate === true && permitted() && !busy) { clearTimeout(timer); swapOne(); } else schedule();
      };
      const move = async (piece, frames, options) => {
        if (!piece.animate) return;
        const animation = piece.animate(frames, options);
        animations.push(animation);
        await animation.finished.catch(() => {});
      };
      async function swapOne() {
        if (!permitted() || busy) return;
        const shown = new Set(pieces.map((piece) => piece.dataset.design));
        const choices = library.filter((entry) => !shown.has(entry.id));
        if (!choices.length) return;
        const replacement = choices[Math.floor(Math.random() * choices.length)];
        const slots = pieces.map((_, index) => index).filter((index) => pieces.length === 1 || index !== lastSlot);
        const slot = slots[Math.floor(Math.random() * slots.length)], piece = pieces[slot];
        busy = true;
        let deadline;
        try {
          const preload = new Image();
          await new Promise((resolve, reject) => {
            const finish = (callback) => { clearTimeout(deadline); preload.onload = null; preload.onerror = null; cancelPreload = null; callback(); };
            preload.onload = () => finish(resolve);
            preload.onerror = () => finish(reject);
            cancelPreload = () => finish(reject);
            deadline = setTimeout(cancelPreload, 10000);
            preload.src = replacement.src;
          });
          if (!permitted()) return;
          await move(piece, [
            { transform: 'translateX(-50%) translateY(0) rotate(0)', opacity: 1 },
            { transform: 'translateX(-50%) translateY(-12px) rotate(-7deg)', opacity: 1, offset: .35 },
            { transform: 'translateX(-50%) translateY(-46px) rotate(-15deg)', opacity: 0 }
          ], { duration: 430, easing: 'cubic-bezier(.4,0,.8,.4)', fill: 'forwards' });
          if (!permitted()) return;
          const img = piece.querySelector('img');
          img.src = replacement.src;
          img.alt = `${replacement.name} magnetic charm`;
          piece.href = replacement.url;
          piece.dataset.design = replacement.id;
          piece.setAttribute('aria-label', `Shop ${replacement.name} CubbyClick`);
          piece.querySelector('span').textContent = replacement.name;
          cancelAnimations();
          await move(piece, [
            { transform: 'translateX(-50%) translateY(-42px) rotate(12deg)', opacity: 0 },
            { transform: 'translateX(-50%) translateY(3px) rotate(-2deg)', opacity: 1, offset: .78 },
            { transform: 'translateX(-50%) translateY(0) rotate(0)', opacity: 1 }
          ], { duration: 620, easing: 'cubic-bezier(.2,.7,.2,1)' });
          lastSlot = slot;
        } catch (_) {
          // Keep the pictured product intact if its replacement cannot load.
        } finally {
          clearTimeout(deadline); cancelAnimations(); busy = false; schedule();
        }
      }
      toggle.addEventListener('click', () => { paused = !paused; changeActivity(); });
      board.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') { hovering = true; changeActivity(); } });
      board.addEventListener('pointerleave', () => { hovering = false; changeActivity(); });
      board.addEventListener('focusin', changeActivity);
      board.addEventListener('focusout', () => setTimeout(changeActivity, 0));
      document.addEventListener('visibilitychange', changeActivity);
      reduced.addEventListener('change', changeActivity);
      const observer = new IntersectionObserver((entries) => { const wasVisible = visible; visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25; changeActivity(visible && !wasVisible); }, { threshold: .25 });
      observer.observe(board);
      const unload = (event) => {
        if (event.target !== home && !event.target.contains(home)) return;
        disposed = true; clearTimeout(timer); cancelAnimations(); if (cancelPreload) cancelPreload(); observer.disconnect();
        document.removeEventListener('visibilitychange', changeActivity);
        reduced.removeEventListener('change', changeActivity);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      updateToggle();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
